import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0a0f] via-[#1a1a2e] to-[#0a0a0f] flex flex-col">
      <SEO
        title="Terms of Service | Charles Kilvington"
        description="Terms of Service for charleskilvington.com"
        ogTitle="Terms of Service | Charles Kilvington"
        ogDescription="Terms of Service for charleskilvington.com"
        ogUrl="https://charleskilvington.com/terms"
        ogImage="https://charleskilvington.com/og-image.jpg"
        twitterImage="https://charleskilvington.com/og-image.jpg"
      />
      <Header />

      <main className="pt-28 md:pt-36 pb-16 px-8 flex-1">
        <div className="max-w-[900px] mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8 group"
          >
            <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
            <span className="font-medium">BACK</span>
          </button>
          <div className="text-center mb-16">
            <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-purple-600 font-['Poppins'] text-6xl font-black mb-6">
              TERMS OF SERVICE
            </h2>
            <div className="h-1 w-32 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
          </div>

          <div className="glass-effect rounded-2xl p-8 md:p-12 space-y-8">
            <div>
              <p className="text-gray-400 mb-8">
                Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>
            </div>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                1. Acceptance of Terms
              </h3>
              <p className="text-gray-300 leading-relaxed">
                By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use this website.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                2. Use License
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4">
                Permission is granted to temporarily view the materials (information or software) on this website for personal, non-commercial use only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or public display</li>
                <li>Attempt to decompile or reverse engineer any software contained on the website</li>
                <li>Remove any copyright or proprietary notations from the materials</li>
              </ul>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                3. Portfolio and Work Samples
              </h3>
              <p className="text-gray-300 leading-relaxed">
                All work samples, videos, images, and creative content displayed on this website are the intellectual property of Charles Kilvington or used with permission. Unauthorized use, reproduction, or distribution of this content is prohibited.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                4. Disclaimer
              </h3>
              <p className="text-gray-300 leading-relaxed">
                The materials on this website are provided on an 'as is' basis. Charles Kilvington makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                5. Limitations
              </h3>
              <p className="text-gray-300 leading-relaxed">
                In no event shall Charles Kilvington or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on this website.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                6. Links to Third-Party Sites
              </h3>
              <p className="text-gray-300 leading-relaxed">
                This website may contain links to third-party websites or services that are not owned or controlled by Charles Kilvington. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                7. Service Inquiries
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Inquiries made through the contact form do not constitute a binding agreement for services. All service agreements must be formally documented and agreed upon by both parties.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                8. Modifications
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Charles Kilvington may revise these terms of service at any time without notice. By using this website, you are agreeing to be bound by the then-current version of these terms of service.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                9. Governing Law
              </h3>
              <p className="text-gray-300 leading-relaxed">
                These terms and conditions are governed by and construed in accordance with the laws of the United States, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                10. Contact Information
              </h3>
              <p className="text-gray-300 leading-relaxed">
                If you have any questions about these Terms of Service, please contact us through our Contact page.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
